import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { api, imgSrc } from "../lib/api";
import { PageHero } from "../components/PageHero";
import { FadeUp } from "../components/Reveal";
import { CtaSection } from "../components/CtaSection";

export default function Kasus() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    api.get("/kasus").then((r) => setItems(r.data)).catch(() => setItems([]));
  }, []);

  return (
    <>
      <PageHero
        eyebrow="Direktori Kasus"
        titleLines={[
          "Kisah nyata perjuangan",
          <span key="t" className="italic text-gold">
            mencari keadilan.
          </span>,
        ]}
        description="Dokumentasi kasus-kasus yang ditangani YLBH Sumatera Timur — ringkasan, kronologi, strategi hukum, hingga hasil akhirnya. Identitas klien disamarkan demi kerahasiaan."
      />

      <section className="mx-auto w-full max-w-7xl px-6 pb-28 lg:px-10">
        {items === null ? (
          <p className="py-20 text-center font-serif text-2xl italic text-[#737373]">Memuat direktori…</p>
        ) : items.length === 0 ? (
          <p data-testid="kasus-empty" className="border border-white/10 bg-[#0d0d0d] py-20 text-center font-serif text-2xl italic text-[#737373]">
            Direktori kasus segera hadir.
          </p>
        ) : (
          <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
            {items.map((k, i) => (
              <FadeUp key={k.id} delay={0.08 * (i % 3)}>
                <Link
                  to={`/kasus/${k.slug}`}
                  data-testid={`kasus-card-${k.slug}`}
                  className="group flex h-full flex-col border border-white/10 bg-[#0d0d0d] transition-colors duration-500 hover:border-gold/40"
                >
                  {k.gambar && (
                    <div className="overflow-hidden">
                      <motion.img
                        src={imgSrc(k.gambar)}
                        alt={k.judul}
                        className="aspect-[16/9] w-full object-cover grayscale-[40%]"
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                      />
                    </div>
                  )}
                  <div className="flex flex-1 flex-col p-7">
                    <p className="text-[10px] font-medium uppercase tracking-[0.3em] text-gold">
                      {k.kategori} — {k.tanggal}
                    </p>
                    <h3 className="mt-3 font-serif text-2xl leading-snug text-[#F5F5F5] transition-colors group-hover:text-gold-light">
                      {k.judul}
                    </h3>
                    <p className="mt-3 line-clamp-3 text-sm font-light leading-relaxed text-[#A3A3A3]">
                      {k.ringkasan_kasus}
                    </p>
                    <span className="mt-auto inline-flex items-center gap-2 pt-5 text-[11px] font-semibold uppercase tracking-[0.25em] text-gold">
                      Baca studi kasus
                      <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                    </span>
                  </div>
                </Link>
              </FadeUp>
            ))}
          </div>
        )}
      </section>

      <CtaSection
        testid="kasus-cta"
        lines={[
          "Menghadapi situasi serupa?",
          <span key="t" className="italic text-gold">
            Ceritakan pada kami.
          </span>,
        ]}
      />
    </>
  );
}
